export function isDateOfServicePriorToDob(dateOfService = null, patientDateOfBirth = null) {
  return patientDateOfBirth && dateOfService < patientDateOfBirth
}
